import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, distinctUntilChanged, map, takeUntil, timer } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { orderMenu } from 'src/app/pages/user-center/left-menu.config';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { environment } from 'src/environments/environment';
import { LeftMenuService } from '../left-menu/left-menu.service';

@UntilDestroy()
@Component({
  selector: 'app-header-level2-menu',
  templateUrl: './header-level2-menu.component.html',
  styleUrls: ['./header-level2-menu.component.scss'],
})
export class HeaderLevel2MenuComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    public appService: AppService,
    private breakpointObserver: BreakpointObserver,
    private leftMenuService: LeftMenuService,
    private router: Router,
  ) {}

  isH5!: boolean;

  simple!: boolean;

  vipLoading: boolean = false;

  /** 是否是app */
  isApp?: boolean;

  /** 是否登录状态 */
  logined: boolean = false;

  showH5Logo: boolean = false;

  showPop$: Subject<boolean> = new Subject();

  orderMenuData = orderMenu;

  @Input() layoutContentMarginLeft: string = '0px';
  @Input() layoutContentMarginRight: string = '0px';

  orderPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 6 },
  ];

  navigationMenus: {
    name: string;
    icon: string;
    routerLink: string;
    menuIcon: string;
    show: boolean;
    linkActive: boolean;
    children: {
      labelName: string;
      ident: string;
      routerLink: string;
      menuIcon: string;
      icon: string;
    }[];
  }[] = [];

  ngOnInit() {
    this.isApp = environment.isApp;
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => (this.isH5 = e));
    this.layout.page$
      .pipe(untilDestroyed(this))
      .subscribe(e => (this.simple = ['register', 'login', 'password'].includes(e)));

    this.breakpointObserver
      .observe(['(max-width: 875px)'])
      .pipe(
        untilDestroyed(this),
        map((state: BreakpointState) => state.matches),
        distinctUntilChanged(),
      )
      .subscribe(e => {
        this.showH5Logo = e;
      });

    // 获取头部导航
    this.leftMenuService
      .onGetTags()
      .pipe(
        untilDestroyed(this),
        map(v => {
          const headerMenu = v?.navigationMenus || [];
          return headerMenu.map(x => {
            const link = this.leftMenuService.getLinkByMethod(x);
            return {
              name: x?.name || '',
              icon: x?.icon || '',
              routerLink: link ? `/${this.appService.languageCode}/${this.leftMenuService.getLinkByMethod(x)}` : '',
              menuIcon: x?.menuIcon || '',
              show: false,
              linkActive: false,
              children: [
                ...(x.infoExpandList?.map(expendList => ({
                  labelName: expendList?.labelName || '',
                  ident: expendList?.labelCode || '',
                  routerLink: `/${this.appService.languageCode}/${this.leftMenuService.getLinkByMethod(expendList)}`,
                  menuIcon: expendList?.menuIcon || '',
                  icon: expendList?.icon || '',
                })) || []),
              ],
            };
          });
        }),
      )
      .subscribe(data => {
        this.navigationMenus = data;
      });
  }

  showPop(i: number, skipRepeat: boolean = true) {
    if (this.isH5) return;
    if (skipRepeat && this.navigationMenus[i].show) return;
    this.closePop();
    this.showPop$.next(true);
    this.navigationMenus[i].show = true;
  }
  clickshowPop(v: number) {
    const show = this.navigationMenus[v].show;
    this.closePop();
    this.showPop$.next(!show);
    this.navigationMenus[v].show = !show;
  }
  closePop(time: number = 0) {
    if (time > 0) {
      timer(time)
        .pipe(takeUntil(this.showPop$))
        .subscribe(() => {
          this.navigationMenus.forEach(x => (x.show = false));
        });
    } else {
      this.navigationMenus.forEach(x => (x.show = false));
    }
  }

  goToMenu(item: any) {
    if (item.children.length == 0) {
      this.navigationMenus.forEach(e => (e.linkActive = false));
      item.linkActive = true;
      this.router.navigateByUrl(item.routerLink);
    }
  }
}
